/**
 * Perimeter of a rounded rect matching the SVG stroke geometry (0.5 inset, pill rx).
 */
export function getRoundedRectPerimeter({ width, height }) {
  const r = Math.min((width - 1) / 2, (height - 1) / 2);
  return 2 * Math.max(0, width - 1 - 2 * r) + 2 * Math.max(0, height - 1 - 2 * r) + 2 * Math.PI * r;
}
